import {
    SET_SUPPLEMENTAL_MEDIA_TAB,
    SHOW_INFO,
    HIDE_INFO,
    SHOW_SUPPLEMENTAL_MEDIA_VIEW,
    HIDE_SUPPLEMENTAL_MEDIA_VIEW,
    SET_MEDIA,
    SHOW_PREVIEW,
} from 'aria-viewer/players/supplementalmedia/supplementalMediaActions'
import { TABS } from 'aria-viewer/tour/constants'
import { Map } from 'immutable'

const INITIAL_STATE = Map({
    tab: TABS.panos,
    infoVisible: false,
    visible: false,
    media: null,
    previewVisible: false,
    showAllMedia: false,
})

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case SET_MEDIA:
            return state.merge({
                media: action.media,
                stopid: action.stopid,
            })
        case SET_SUPPLEMENTAL_MEDIA_TAB:
            return state.set('tab', action.option)
        case SHOW_SUPPLEMENTAL_MEDIA_VIEW:
            return state.set('visible', true).set('showAllMedia', action.showAllMedia)
        case HIDE_SUPPLEMENTAL_MEDIA_VIEW:
            return state.set('visible', false)
        case SHOW_INFO:
        case HIDE_INFO:
            return state.set('infoVisible', action.type === SHOW_INFO)
        case SHOW_PREVIEW:
            return state.set('previewVisible', action.visible)
        default:
            return state
    }
}
